module.exports = "/images/arrowUpCircle.png?5f21388781c52f2eaf91be3f163db7ad";